angular
	.module 'App.Module.Integration', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, LEGACY_INTEGRATIONS) ->
		$stateProvider
			.state 'integrations',
				abstract: true

			.state 'integrations.list',
				url: '/integrations',
				views:
					'main@':
						controller: 'IntegrationController'
						controllerAs: 'vm'
						templateUrl: '@app/integration/integration.list.view.html'
				data:
					pageTitle: 'Integrations'
					hideMenu: false
					hideSubMenu: true
					restrict: "Backoffice.TopMenu.Setting.Integrations"

				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					integrations: (IntegrationRepository) ->
						return IntegrationRepository.getEntities()

			.state 'integrations.static_callback',
				url: '/static_callback/:id?state&code'
				views:
					'main@':
						template: '<!-- Eaccounting callback -->'
						controller: 'EaccountingStaticCallbackController'

			.state 'integrations.xero_callback',
				url: '/integrations/xero/callback?code&state&error'
				views:
					'main@':
						controller: 'XeroAuthController'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					integrations: (IntegrationRepository) ->
						return IntegrationRepository.getEntities()

			.state 'integrations.unimicro_callback',
				url: '/integrations/unimicro/callback?code&state&error'
				views:
					'main@':
						controller: 'UnimicroAuthController'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					integrations: (IntegrationRepository) ->
						return IntegrationRepository.getEntities()

			.state 'integrations.integration',
				abstract: true
				views:
					'main@':
						controller: 'IntegrationController'
						controllerAs: 'vm'
						templateUrl: '@app/integration/integration.view.html'
				data:
					pageTitle: 'Integrations'
					hideMenu: false
					hideSubMenu: true
					restrict: "Backoffice.TopMenu.Setting.Integrations"

				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					integrations: (IntegrationRepository) ->
						return IntegrationRepository.getEntities()
					VatRates: (VatRateRepository) ->
						return VatRateRepository.list()

			.state 'integrations.integration.details',
				url: '/integrations/:id/:action?success&message&code&state&error'
				views:
					entity_view:
						controllerProvider: ($stateParams) ->
							if _.isEmpty($stateParams.id)
								throw new Error('Integration ID is empty')

							# Convert /integrations/foo_bar/config into FooBarController
							identifier = $stateParams
								.id
								.split '_'
								.map (part) -> part.charAt(0).toUpperCase() + part.substring(1)
								.join ''

							if LEGACY_INTEGRATIONS.includes($stateParams.id)
								identifier += $stateParams.action.charAt(0).toUpperCase() + $stateParams.action.substring(1)

							return "#{identifier}Controller"
						controllerAs: 'vm'
						templateUrl: ($stateParams) ->
							if _.isEmpty($stateParams.id)
								return null

							identifier = $stateParams
								.id
								.replace(/([a-z0-9])([A-Z])/g, '$1-$2')
								.replaceAll('_', '-')
								.toLowerCase()

							if LEGACY_INTEGRATIONS.includes($stateParams.id)
								action = '.' + $stateParams.action.replace(/([A-Z])/g, '-$1').toLowerCase()
							else
								action = ''

							return "@app/integration/#{identifier}/#{identifier}#{action}.view.html"
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					# @TODO: remove. Legacy
					Integration: (IntegrationRepository, integrations, $stateParams) ->
						if $stateParams.action == 'config' && 'mobilepay' == $stateParams.id
							IntegrationRepository
								.findById $stateParams.id
								.catch ->
									return {}
						else
							return {data: _.find(integrations, {id: $stateParams.id})}
					IntegrationConfigurationOptions: (IntegrationRepository, $stateParams) ->
						if $stateParams.action == 'connect'
							return []

						IntegrationRepository
							.getConfigurationOptions $stateParams.id
							.catch ->
								return {}
					configurationOptions: (IntegrationConfigurationOptions, $stateParams) ->
						if $stateParams.action == 'config' && !_.isEmpty IntegrationConfigurationOptions.data
							return IntegrationConfigurationOptions.data

						return {}
					IntegrationConfiguration: (IntegrationRepository, $stateParams, Integration) ->
						if $stateParams.action == 'connect' || Integration.data?.is_connected == false
							return {}

						return IntegrationRepository
							.getConfiguration $stateParams.id
							.catch ->
								return {}
					configuration: (IntegrationConfiguration) ->
						if !_.isEmpty IntegrationConfiguration.data
							return IntegrationConfiguration.data

						return {}
					suppliers: ($stateParams, SuppliersRepository) ->
						if ['netsuite'].includes($stateParams.id)
							return SuppliersRepository.getEntities()
					vatRates: ($stateParams, VatRateRepository) ->
						if ['netsuite', 'fiskaly_es', 'infor_m3', 'eaccounting'].includes($stateParams.id)
							return VatRateRepository.getEntities()
					users: ($stateParams, UserRepository, BACKEND_USER_ENTITY_TYPE) ->
						if ['netsuite'].includes($stateParams.id)
							query = UserRepository.createQuery()
							query.criteria 'entity_type', '=', BACKEND_USER_ENTITY_TYPE.USER

							return UserRepository.getEntities query
					units: (UnitRepository, $stateParams) ->
						if ['infor_m3'].includes($stateParams.id)
							return UnitRepository.getEntities()
					shopGroups: (ShopGroupRepository, $stateParams) ->
						if ['sj_trains'].includes($stateParams.id)
							return ShopGroupRepository.getEntities()
					Products: (ProductRepository, $stateParams) ->
						if $stateParams.action == 'config' && ['eaccounting', 'netsuite'].includes($stateParams.id)
							query = ProductRepository.createQuery()
							query.criteria 'source', '!=', $stateParams.id
							query.setPagination 0, 1

							return ProductRepository.findByQuery query
					Shops: (ShopRepository, $stateParams) ->
						if ['accountingSftpGbat10', 'diller', 'accountingSftpSie4', 'deliverect', 'svea', 'resursbank', 'xero', 'fiskaly_es', 'diller_v2', 'unimicro'].includes($stateParams.id)
							query = ShopRepository.createQuery()
							query.with('entity_attribute_relation')

							ShopRepository
								.findByQuery query
								.then (response) ->
									response.data = response.data.map (shop) ->
										shop.attributes = ShopRepository.getAttributesAsObject(shop.attributes, ['cost_center_id'])

										return shop

									return response
						else
							return {}
					shops: (ShopRepository, $stateParams) ->
						if ['infor_m3', 'vipps_mobile_pay', 'eaccounting', 'netsuite', 'low_stock_email_notifications', 'mail_chimp', 'fiskaly_pt', 'fiskaly_it'].includes($stateParams.id)
							query = ShopRepository.createQuery()
							query.with('entity_attribute_relation')

							return ShopRepository
								.getEntities(query)
								.then (response) ->
									return response.map (shop) ->
										shop.attributes = ShopRepository.getAttributesAsObject(shop.attributes, ['cost_center_id'])
										return shop
					customerGroups: (CustomerGroupRepository, $stateParams) ->
						if ['mail_chimp'].includes($stateParams.id)
							return CustomerGroupRepository.getEntities()
					priceRegions: (PriceRegionRepository, $stateParams) ->
						if ['eaccounting', 'netsuite', 'sj_trains'].includes($stateParams.id)
							query = PriceRegionRepository.createQuery()
							query.with 'vat_rate'

							return PriceRegionRepository.getEntities query
					layoutTemplates: (ConfigurationService, LayoutTemplateRepository, $stateParams, BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE) ->
						if ConfigurationService.isDisabled 'Backoffice.Permission.LayoutTemplates.Enabled'
							return []

						if ['sj_trains'].includes($stateParams.id)
							query = LayoutTemplateRepository.getQuery()
							query.criteria 'entity_type', '!=', BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE.PREDEFINED

							return LayoutTemplateRepository.getEntities(query)
					TenderTypes: (TenderTypeRepository, $stateParams) ->
						if ['accountingSftpSSP', 'accountingSftpGbat10', 'accountingSftpSie4', 'eaccounting', 'xero', 'unimicro'].includes($stateParams.id)
							query = TenderTypeRepository.createQuery()

							return TenderTypeRepository.findByQuery query
					ProductCategories: (ProductCategoryRepository, $stateParams) ->
						if ['xero', 'unimicro'].includes($stateParams.id)
							query = ProductCategoryRepository.createQuery()

							return ProductCategoryRepository.findByQuery query

						return null
					vatRateOverrides: (VatRateOverrideGroupRepository, $stateParams) ->
						if ['sj_trains'].includes($stateParams.id)
							return VatRateOverrideGroupRepository.getEntities()
